import type { IconPathProps } from 'cdh-data-portal-theme'

export interface FilterOption {
  readonly id: string
  readonly name: string
}

export type FilterFacetKey = 'hub' | 'businessObject'

export interface FilterFacet {
  readonly key: FilterFacetKey
  readonly title: string
  readonly icon: IconPathProps
  readonly options: readonly FilterOption[]
}

export const localText = {
  searchPlaceholder: 'Search by email',
  filtersButton: 'Filters',
  hubFilterLabel: 'Hub',
  businessObjectFilterLabel: 'Business object',
} as const
